import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";

export const Reveal = ({ children, delay = 0, className = "", as = "div" }) => {
  const M = motion[as];
  return (
    <M className={className} initial={{ opacity: 0, y: 24 }} whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-60px" }} transition={{ duration: 0.7, delay, ease: [0.22, 1, 0.36, 1] }}>
      {children}
    </M>
  );
};

export const PageFade = ({ children }) => (
  <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 0.45 }}>{children}</motion.div>
);

export const Breadcrumbs = ({ items }) => (
  <nav aria-label="Fil d'Ariane" data-testid="breadcrumbs" className="flex flex-wrap items-center gap-2 text-sm text-[#242020]/70">
    {items.map((it, i) => (
      <span key={i} className="flex items-center gap-2">
        {i > 0 && <ChevronRight className="h-3.5 w-3.5 text-[#650D23]" />}
        {it.to ? (
          <Link to={it.to} className="hover:text-[#650D23]" data-testid={`breadcrumb-${i}`}>{it.label}</Link>
        ) : (
          <span className="text-[#242020]" data-testid={`breadcrumb-${i}`}>{it.label}</span>
        )}
      </span>
    ))}
  </nav>
);

export const Container = ({ children, className = "" }) => (
  <div className={`mx-auto max-w-7xl px-5 sm:px-8 lg:px-12 ${className}`}>{children}</div>
);
